"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Attribution;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
const AttributionBox = /*#__PURE__*/(0, _react2.styled)("span")({
  name: "AttributionBox",
  class: "pl-a1km669j",
  vars: {
    "a1km669j-0": [({
      fontWeight
    }) => fontWeight || 'initial']
  }
});
function Attribution({
  attribution,
  attributionHeadline,
  attributionDescription,
  fontWeight = 'initial',
  formatLegacy
}) {
  if (attributionHeadline || attributionDescription) {
    return /*#__PURE__*/_react.default.createElement("div", {
      style: {
        position: 'relative'
      }
    }, attributionHeadline && /*#__PURE__*/_react.default.createElement("div", null, attributionHeadline), attributionDescription && /*#__PURE__*/_react.default.createElement(AttributionBox, {
      fontWeight: fontWeight
    }, attributionDescription));
  }
  if (attribution && typeof formatLegacy === 'function') {
    return formatLegacy();
  }
  return null;
}
Attribution.propTypes = {
  attribution: _propTypes.default.string,
  attributionHeadline: _propTypes.default.string,
  attributionDescription: _propTypes.default.string,
  fontWeight: _propTypes.default.string,
  formatLegacy: _propTypes.default.func.isRequired
};